// extracted by mini-css-extract-plugin
var _1 = "EntityTabAttributes-modulecontainer__N32jd";
var _2 = "EntityTabAttributes-moduledivider__SOKYg Divider-moduleDivider__dL3Vg";
var _3 = "EntityTabAttributes-moduleentry__Ay1Jv";
var _4 = "EntityTabAttributes-moduleheader__EE7tT";
var _5 = "EntityTabAttributes-moduleheaderDivider__FyrOk Divider-moduleDivider__dL3Vg";
export { _1 as "container", _2 as "divider", _3 as "entry", _4 as "header", _5 as "headerDivider" }
